import React from "react";
import clsx from "clsx";
import { GlassLoader } from "./GlassComponents";
import { useDesignSystem } from "../../lib/design/designSystem";
import { useTranslation } from "react-i18next";

interface FullScreenLoaderProps {
  text?: string;
  className?: string;
  fullHeight?: boolean;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  text,
  className,
  fullHeight = true,
}) => {
  const { t } = useTranslation('common');
  const resolvedText = text ?? t('loading.loading');
  const { surfaces } = useDesignSystem();

  const containerClass = clsx(
    fullHeight ? "min-h-screen" : "min-h-[320px]",
    "w-full flex items-center justify-center px-4",
    surfaces.canvas,
    "backdrop-blur-lg",
    className
  );

  return (
    <div className={containerClass}>
      <GlassLoader size="lg" text={resolvedText} />
    </div>
  );
};

export default FullScreenLoader;
